/** Date string to input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string =>
  v ? v.substring(0, 10) : '';

/** Input value to ISO date string */
export const inputToDate = (v: string): string | null =>
  v ? v + 'T00:00:00Z' : null;

/** Format number for display */
export const fmt = (v: number | null | undefined): string =>
  v == null || v === 0
    ? '0'
    : v.toLocaleString('en-US', { maximumFractionDigits: 2 });

/** Parse float safely, returns 0 on NaN */
export const safeFloat = (v: string): number => {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
};

/** Payment category labels */
export const PAYMENT_CATEGORIES: { value: string; label: string; description: string }[] = [
  { value: '1', label: '貨款', description: '指直接供生產所需的原料、成品、半成品、配件、加工工繳' },
  { value: '2', label: '直接單位-直接費用', description: '指營業單位因訂單銷售、採購所產生之費用，可歸屬至S/C' },
  { value: '3', label: '直接單位-間接費用', description: '指營業單位因執行業務所產生之費用，無法歸屬至S/C' },
  { value: '4', label: '間接單位-間接費用', description: '指間接單位因執行間接業務所產生之費用' },
  { value: '5', label: '營業外支出', description: '指非公司營運作業上所需的支出' },
  { value: '6', label: '採購佣金-直接', description: '原隸屬於直接單位直接費用,因請款單格式不同,故另獨立處理' },
  { value: '7', label: '銷售佣金-直接', description: '原隸屬於直接單位直接費用,因請款單格式不同,故另獨立處理' },
];

/** Payment method options */
export const PAYMENT_METHODS: { value: string; label: string }[] = [
  { value: '01', label: '現金' },
  { value: '02', label: '押匯' },
  { value: '03', label: '支票' },
  { value: '04', label: '電匯' },
  { value: '05', label: '轉帳' },
  { value: '06', label: '沖暫借款' },
  { value: '08', label: '沖代墊款' },
  { value: '11', label: '應付代付款' },
];

/** Income category options */
export const INCOME_CATEGORIES: { value: number; label: string }[] = [
  { value: 1, label: '租賃' },
  { value: 2, label: '利息' },
  { value: 3, label: '權利金' },
  { value: 4, label: '盈餘' },
  { value: 5, label: '執行業務報酬' },
  { value: 6, label: '競技競賽' },
  { value: 7, label: '機會中獎獎金' },
];

/**
 * Approval status badge color.
 * FH110_80 對齊規格 pwh201f1（批次 5 狀態機重寫）：
 * ''/'N'=未送審（草稿）、'D'=送審中、'P'=已核准（規格另有 'A'=會計審核中，核准系）。
 * 規格 Q/B/C/1~5 多級審核碼位現未使用，不引入。
 */
export const getApprovalStatusInfo = (status: string): { label: string; color: string } => {
  switch (status) {
    case 'P': return { label: '已核准', color: 'green' };
    case 'A': return { label: '會計審核中', color: 'green' };
    case 'D': return { label: '送審中', color: 'blue' };
    default: return { label: '未送審', color: 'default' };
  }
};

/** Check if record is locked（規格：僅 ''/'N' 草稿可修改/刪除）*/
export const isRecordLocked = (status: string | undefined): boolean => {
  const s = (status || '').trim();
  return s !== '' && s !== 'N';
};

/** Calculate total from invoice details */
export const calcInvoiceTotals = (invoices: Array<{ fh113_16?: number; fh113_17?: number }>): {
  netTotal: number;
  taxTotal: number;
  grandTotal: number;
} => {
  const netTotal = invoices.reduce((s, d) => s + (d.fh113_16 || 0), 0);
  const taxTotal = invoices.reduce((s, d) => s + (d.fh113_17 || 0), 0);
  return { netTotal, taxTotal, grandTotal: netTotal + taxTotal };
};
